<template lang="pug">
  include ./../../../mixins
  +b.popup-inner.modal-form-community
    +e.close-popup(@click='closeModal()')
    +b.wrap
      +b.el--p_r_md-till-xl
        +b.H3.ds-caption--size_30xl-md.--size_lg.--w_r.--c_white.--h_130.--upp {{trans.titleRadio}}
      +b.el--p_t_lg-md.--p_t_md
        +b.g-row
          +b.g-cols--12.--6-sm.--4-lg.g-cell(v-for="(item, index) in listSelect" )
            +b.el.radio-topic
              +b.custom-radio
                label
                  input(
                    type='radio'
                    name='topic'
                    :id="'topic' + index"
                    :value="item"
                    v-model="formData.topic"
                    @change="sendDataForm()"
                    ref="child"
                  )
                  +b.custom-radio__label
                    +b.text {{item}}
    slot(
      name="content"
    )
</template>

<script>

export default {
  data() {
    return {
      formData: {
        topic: '',
      },
    }
  },
  props: {
    trans: {},
    dataValue: {},
    listSelect: {},
    updateData: {},
  },
  mounted() {
    if (this.dataValue) {
      this.formData.topic = this.dataValue
    }
  },
  methods: {
    sendDataForm() {
      this.updateData(this.formData.topic)
    },
    closeModal() {
      this.$nextTick(() => {
        this.$emit('close')
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// ./src/js/components/app/Modals/ModalTopic.vue